import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import Home from './pages/Home';
import Dashboard from './pages/Dashboard';
import CreateBooking from './pages/CreateBooking';
import BookingHistory from './pages/BookingHistory';
import BookingDetails from './pages/BookingDetails';
import Notifications from './pages/Notifications';
import { NotificationProvider } from "./context/NotificationContext";
import Settings from './pages/Settings';


function App() {
  return (
    <Router>
      <NotificationProvider>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/create-booking" element={<CreateBooking />} />
          <Route path="/booking-history" element={<BookingHistory />} />
          <Route path="/booking-details" element={<BookingDetails />} />
          <Route path="/notifications" element={<Notifications />} />
          <Route path="/settings" element={<Settings />} />
        </Routes>
      </NotificationProvider>
    </Router>
  );
}

export default App;